import type { RouteRecordRaw } from 'vue-router';

export const myProfileRoutes: RouteRecordRaw[] = [
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => import('./views/MyProfileView.vue'),
    meta: {
      title: 'My Profile',
      breadcrumbs: [{ label: 'My Profile' }],
    },
  },
];
